export const SPECIALITY_OPTIONS = [
  { id: "1", label: "Asian Automobiles" },
  { id: "2", label: "European Automobiles" },
  { id: "3", label: "American Automobiles" },
  { id: "4", label: "Standard Repair & Maintenance" },
  { id: "5", label: "Advanced Mechanical" },
  { id: "6", label: "Electrical" },
  { id: "7", label: "Wheel & Tire" },
  { id: "8", label: "Inspections" },
  { id: "9", label: "Performance & Tuning" },
  { id: "10", label: "Cosmetic and Collision" },
];

export function normalizeSpecialities(values) {
  return Array.from(new Set((values || []).map(String))).sort((a, b) => Number(a) - Number(b));
}
